/**
 * Shared horizontal content column for marketing chrome (nav, footer) and page bodies.
 *
 * Stitch baseline: ~1200px max width with 16px / 24px / 40px gutters.
 * Prefer the CSS class `homepage-wrapper` (same rules) in JSX; use this constant
 * when composing class names in TypeScript.
 */
export const MARKETING_CONTENT_WIDTH_CLASSNAME =
  'relative mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-10';
